export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? "https://smartlyorder.com";

export const CUSTOMER_APP_URL: string =
  import.meta.env.VITE_CUSTOMER_APP_URL ?? "https://smartlyorder.com";

export const VENDOR_APP_URL: string =
  import.meta.env.VITE_VENDOR_APP_URL ?? "https://smartlyorder.com/vendor";
